import { Card } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Carlos Silva',
    location: 'São Paulo, SP',
    text: 'Economizei mais de R$ 15.000 na compra do meu carro usando o LEILIZE. A plataforma é precisa e fácil de usar.',
    rating: 5,
    initials: 'CS',
  },
  {
    name: 'Marina Oliveira',
    location: 'Rio de Janeiro, RJ',
    text: 'Ferramenta essencial para quem quer comprar carros em leilão com segurança. Recomendo para todos os meus amigos!',
    rating: 5,
    initials: 'MO',
  },
  {
    name: 'Roberto Santos',
    location: 'Belo Horizonte, MG',
    text: 'Interface intuitiva e resultados instantâneos. Consegui identificar ótimas oportunidades que passariam despercebidas.',
    rating: 5,
    initials: 'RS',
  },
];

export function Testimonials() {
  return (
    <section className="py-20 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-4">
            O Que Dizem Nossos Usuários
          </h2>
          <p className="text-lg text-muted-foreground">
            Histórias reais de economia e sucesso em leilões
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="p-6 h-full hover:shadow-lg transition-all border-border/50">
                <div className="space-y-4">
                  <div className="flex items-center gap-1">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                    ))}
                  </div>

                  <p className="text-muted-foreground">{testimonial.text}</p>

                  <div className="flex items-center gap-3 pt-4 border-t border-border/50">
                    <Avatar>
                      <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                        {testimonial.initials}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <p className="font-semibold">{testimonial.name}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
